<template>
  <div class="content ht-100v pd-0">
    <template>
      <div ref="mainHeader" class="content-header bd-b pd-0 bg-core-light">
        <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px;">
          <div class="dropdown">
            <a class="navbar-brand tx-bold tx-spacing--2 order-1"
              >Хяналтын самбар
            </a>
          </div>
        </nav>
      </div>
      <div class="content-body pd-x-0 pd-y-0 overflow-hidden">
        <div class="container-fluid pd-x-0" id="cstmScrll">
          <div
            v-if="loading"
            class="d-flex align-items-center justify-content-between text-center"
            style="height: calc(100vh - 60px)"
          >
            <span></span>
            <span>Түр хүлээнэ үү...</span>
            <span></span>
          </div>
          <div v-else class="row no-gutters">
            <div class="col-3 bg-white">
              <div
                class="d-flex align-items-center ht-55 bd-b pd-x-10 justify-content-between"
              >
                <a
                  @click="init(new Date().getFullYear())"
                  class="mg-r-10"
                  role="button"
                >
                  <feather type="refresh-ccw" :size="16"></feather>
                </a>
                <Cascader
                  :options="filterData"
                  size="mini"
                  @change="yearOnChange"
                ></Cascader>
                <div class="mg-l-auto">
                  {{ filter.year }}он
                  <span
                    v-if="
                      filter.month != undefined &&
                        filter.month != null &&
                        filter.month != ''
                    "
                    >{{ filter.month }}-р сар</span
                  >
                </div>
              </div>
              <vue-custom-scrollbar
                :style="`height: calc(100vh - 110px)`"
                :settings="{ maxScrollbarLength: 60 }"
              >
                <div class="pd-x-10 pd-y-15">
                  <table
                    class="table table-striped table-hover table-sm tx-thin"
                  >
                    <thead>
                      <tr>
                        <th scope="col wd-40">№</th>
                        <th scope="col">Сургалт</th>
                        <th scope="col wd-80 text-center">
                          <feather type="users"></feather>
                        </th>
                        <th scope="col wd-40"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(c, i) in activity.course.list" :key="i">
                        <td scope="row tx-11 tet-center">{{ i + 1 }}</td>
                        <td class="font-weight-bold">
                          <a @click="courseDetail(c)" role="button">{{
                            c.task
                          }}</a>
                          <div class="tx-12 text-muted">
                            {{ c.dueStartDate | moment("YYYY.MM.DD") }}-{{
                              c.dueDate | moment("YYYY.MM.DD")
                            }}
                          </div>
                        </td>
                        <td class="text-right">
                          {{ c.memberCount }}
                          <a
                            v-if="courseCur == c.id"
                            @click="
                              courseCur = null;
                              mode = 0;
                            "
                            role="button"
                          >
                            <feather type="x" class="tx-danger"></feather>
                          </a>
                        </td>
                        <td>
                          <a @click="taskDetail(c.id)" role="button">
                            <feather type="external-link" :size="16"></feather>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </vue-custom-scrollbar>
            </div>
            <div class="col-9 bd-l">
              <div
                class="ht-55 bd-b d-flex align-items-center justify-content-between"
              >
                <div
                  class="d-flex align-items-center justify-content-between text-center pd-x-15"
                >
                  <div class="mg-r-30">
                    <h5 class="mg-b-0">{{ activity.course.active }}</h5>
                    <span class="tx-thin th-12 text-muted"
                      >Идэвхитэй сургалт</span
                    >
                  </div>
                  <div class="mg-r-30">
                    <h5 class="mg-b-0">{{ activity.course.finished }}</h5>
                    <span class="tx-thin th-12 text-muted">Дууссан</span>
                  </div>
                  <div>
                    <h5 class="mg-b-0">{{ activity.course.notStarted }}</h5>
                    <span class="tx-thin th-12 text-muted">Удахгүй эхлэх</span>
                  </div>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between text-center pd-x-15"
                >
                  <div class="mg-r-30">
                    <h5 class="mg-b-0">{{ activity.invoice.all }}</h5>
                    <span class="tx-thin th-12 text-muted">Нэхэмжлэх</span>
                  </div>
                  <div class="mg-r-30">
                    <h5 class="mg-b-0">{{ activity.user.all }}</h5>
                    <span class="tx-thin th-12 text-muted">Нийт хэрэглэгч</span>
                  </div>
                  <div>
                    <h5 class="mg-b-0">{{ activity.user.distincted }}</h5>
                    <span class="tx-thin th-12 text-muted"
                      >Давтагдаагүй хэрэглэгч</span
                    >
                  </div>
                </div>
              </div>
              <vue-custom-scrollbar
                :style="`height:calc(100vh - 110px)`"
                :settings="{ maxScrollbarLength: 60 }"
                class="pd-x-15 pd-y-20"
              >
                <section v-if="mode == 0">
                  <div class="row">
                    <div class="col-6">
                      <div class="card">
                        <div class="card-header">Эхлэх сургалтын тоо</div>
                        <div class="card-body">
                          <apexchart
                            :key="chartKey"
                            type="bar"
                            height="350"
                            :options="chartOptions"
                            :series="series"
                          ></apexchart>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="card">
                        <div class="card-header">Гишүүний тоо</div>
                        <div class="card-body">
                          <apexchart
                            :key="chartKey + '_mmbr'"
                            type="bar"
                            height="350"
                            :options="chartOptions"
                            :series="seriesMember"
                          ></apexchart>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        id="home-tab"
                        data-toggle="tab"
                        href="#home"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                        >Шилдэг контентууд</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="profile-tab"
                        data-toggle="tab"
                        href="#profile"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                        >Шинэ контентууд</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="contact-tab"
                        data-toggle="tab"
                        href="#contact"
                        role="tab"
                        aria-controls="contact"
                        aria-selected="false"
                        >Сургалтад хамрагдсан</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="contentView-tab"
                        data-toggle="tab"
                        href="#contentView"
                        role="tab"
                        aria-controls="contentView"
                        aria-selected="false"
                        >Контент үзэлт</a
                      >
                    </li>
                    <li class="nav-item">
                      <a @click="loadUsersF()"
                        class="nav-link pos-relative"
                        id="onlineView-tab"
                        data-toggle="tab"
                        href="#onlineView" role="tab" aria-controls="onlineView" aria-selected="false"
                        >Онлайн хэрэглэгч
                         <sup>
                           ({{$store.state.signalr.users.filter(x=>x.isOnline=='b').length}}/{{$store.state.signalr.users.length}})
                         </sup>
                      </a>
                    </li>
                  </ul>
                  <div
                    class="tab-content bd bd-gray-300 bd-t-0 bg-white"
                    id="myTabContent"
                  >
                    <div
                      class="tab-pane fade show active"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <div class="row">
                        <div class="col-sm-8">
                          <ul class="list-group">
                            <li
                              class="list-group-item d-flex align-items-center bd-t-0 bd-r-0 bd-l-0"
                              v-for="(c, i) in activity.content.topList"
                              :key="i"
                            >
                              <div class="text-muted">
                                {{ i + 1 }}
                              </div>
                              <img
                                :src="`${myResBaseUrl}media/mime/${c.ext}.png`"
                                class="rounded wd-45 ht-45 mg-x-10"
                              />
                              <div class="">
                                <h6
                                  @click="showFile(c.id)"
                                  :title="c.name"
                                  class="tx-13 tx-inverse tx-semibold mg-b-0"
                                  role="button"
                                >
                                  {{ c.name }}
                                </h6>
                                <div class="tx-12 text-muted">Сургалтын нэр: {{c.courseName}}</div>
                                <div class="tx-12 text-muted">Хичээлийн нэр: {{c.lessonName}}</div>
                                <div class="text-muted p-r-xs tx-11">
                                  <div>
                                    хэмжээ:
                                    {{
                                      c.size > 1024
                                        ? (c.size / 1024 / 1024).toFixed(2) +
                                          "MB"
                                        : (c.size / 1024).toFixed(2) + "KB"
                                    }}
                                  </div>
                                </div>
                              </div>
                              <div class="mg-l-auto d-flex">
                                <span>{{ c.count }}</span>
                                <feather
                                  type="eye"
                                  :size="16"
                                  stroke-width="1"
                                  class="mg-l-5"
                                ></feather>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div class="col-sm-4 bd-l">
                          <apexchart
                            type="donut"
                            :options="{
                              labels: activity.content.extGrouped.map(x => {
                                return x.ext;
                              })
                            }"
                            :series="
                              activity.content.extGrouped.map(x => {
                                return x.count;
                              })
                            "
                          ></apexchart>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="profile"
                      role="tabpanel"
                      aria-labelledby="profile-tab"
                    >
                      <ul class="list-group">
                        <li
                          class="list-group-item d-flex align-items-center bd-t-0 bd-r-0 bd-l-0"
                          v-for="(c, i) in activity.content.recentList"
                          :key="i"
                        >
                          <div class="text-muted">
                            {{ i + 1 }}
                          </div>
                          <img
                            :src="`${myResBaseUrl}media/mime/${c.ext}.png`"
                            class="rounded wd-45 ht-45 mg-x-10"
                          />
                          <div class="">
                            <h6
                              @click="showFile(c.id)"
                              :title="c.name"
                              class="tx-13 tx-inverse tx-semibold mg-b-0"
                              role="button"
                            >
                              {{ c.name }}
                            </h6>
                            
                            <div class="tx-12 text-muted">Сургалтын нэр: {{c.courseName}}</div>
                            <div class="tx-12 text-muted">Хичээлийн нэр: {{c.lessonName}}</div>

                            <div class="text-muted p-r-xs tx-11">
                              <div>
                                хэмжээ:
                                {{
                                  c.size > 1024
                                    ? (c.size / 1024 / 1024).toFixed(2) + "MB"
                                    : (c.size / 1024).toFixed(2) + "KB"
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="mg-l-auto d-flex">
                            <span>{{ c.count }}</span>
                            <feather
                              type="eye"
                              :size="16"
                              stroke-width="1"
                              class="mg-l-5"
                            ></feather>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="contact"
                      role="tabpanel"
                      aria-labelledby="contact-tab"
                    >
                      <ul class="list-group">
                        <li
                          class="list-group-item d-flex align-items-center bd-t-0 bd-r-0 bd-l-0"
                          v-for="(c, i) in activity.user.mostJoined"
                          :key="i"
                        >
                          <div class="text-muted">
                            {{ i + 1 }}
                          </div>
                          <img
                            @click="handleUserInfoModal(c.user.id)"
                            :src="c.user.avator"
                            class="rounded wd-45 ht-45 mg-x-10"
                            role="button"
                          />
                          <div class="">
                            <h6
                              @click="handleUserInfoModal(c.user.id)"
                              :title="c.name"
                              class="tx-13 tx-inverse tx-semibold mg-b-0"
                              role="button"
                            >
                              {{ c.user.fullName }}
                            </h6>
                            <div class="text-muted p-r-xs tx-11">
                              {{ c.user.loginName }}
                            </div>
                          </div>
                          <div class="mg-l-auto d-flex">
                            <span>{{ c.count }}</span>
                            <feather
                              type="award"
                              :size="16"
                              stroke-width="1"
                              class="mg-l-5"
                            ></feather>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="contentView"
                      role="tabpanel"
                      aria-labelledby="contact-tab"
                    >
                      <ul class="list-group">
                        <li
                          class="list-group-item d-flex align-items-center bd-t-0 bd-r-0 bd-l-0"
                          v-for="(c, i) in activity.user.contentViews"
                          :key="i"
                        >
                          <div class="text-muted">
                            {{ i + 1 }}
                          </div>
                          <img
                            @click="handleUserInfoModal(c.user.id)"
                            :src="c.user.avator"
                            class="rounded wd-45 ht-45 mg-x-10"
                            role="button"
                          />
                          <div class="">
                            <h6
                              @click="handleUserInfoModal(c.user.id)"
                              :title="c.name"
                              class="tx-13 tx-inverse tx-semibold mg-b-0"
                              role="button"
                            >
                              {{ c.user.fullName }}
                            </h6>
                            <div class="text-muted p-r-xs tx-11">
                              {{ c.user.loginName }}
                            </div>
                          </div>
                          <div class="mg-l-auto d-flex">
                            <span>{{ c.count }}</span>
                            <feather
                              type="eye"
                              :size="16"
                              stroke-width="1"
                              class="mg-l-5"
                            ></feather>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div
                      class="tab-pane fade"
                      id="onlineView"
                      role="tabpanel"
                      aria-labelledby="contact-tab"
                    >
                      <div class="d-flex wd-100p">
                        <div class="pd-10 bd-r bg-light wd-300">
                          <div>
                            <!-- <button class="btn btn-primary btn-xs">Хайх</button> -->
                            <button @click="clrFltr()" class="btn btn-long btn-primary btn-xs">Бүгд</button>
                          </div>
                          <input
                              v-model="filterParam.fullname"
                              type="text"
                              class="form-control form-control-sm mg-t-10"
                              placeholder="Хайх утгаа оруулна уу"
                            />
                          <div class="mg-t-10">
                            <div>
                              <Tree
                                ref="departTree" :key="filterParam.trkey"
                                :filter-node-method="filterNode"
                                node-key="id"
                                node-key1="label"
                                :data="departs"
                                :props="defaultProps"
                                highlight-current
                                auto-expand-parent
                                class="depart-tree pd-10"
                              >
                                <div
                                  @click="departNodeClicked(node.key)"
                                  slot-scope="{ node }"
                                  class="d-flex align-items-center wd-100p"
                                >
                                  <div class="tx-color-02">
                                    {{ node.label }}
                                  </div>
                                </div>
                              </Tree>
                            </div>
                            
                          </div>
                        </div>
                        <ul class="list-group wd-100p overflow-auto" style="max-height: 80vh">
                          <li @click="handleUserInfoModal(u.id)" role="button"
                            class="list-group-item d-flex align-items-center bd-t-0 bd-r-0 bd-l-0"
                            v-for="(u, i) in users_filtered"
                            :key="i"
                          >
                            <div class="text-muted">
                              {{ i + 1 }}
                            </div>
                            
                            <img                            
                              :src="u.f06"
                              class="rounded wd-45 ht-45 mg-x-10"
                              role="button"
                            />
                            <div class="">
                              <h6
                                class="tx-13 tx-inverse tx-semibold mg-b-0"
                                role="button"
                              >
                                {{ u.f02 }}
                              </h6>
                              <div class="text-muted p-r-xs tx-11" v-if="u.f09.length">
                                {{ u.f09[0].p01 }}, {{ u.f09[0].p07 }}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </section>
                <section v-else-if="mode == 1 || mode == 2">
                  <div class="row">
                    <div class="col-4">
                      <div class="card">
                        <div class="card-header">Хичээлүүд</div>
                        <div class="card-body" style="padding: 0">
                          <table class="table-god table">
                            <thead style="font-size: 10px">
                              <tr>
                                <th style="width: 40px">№</th>
                                <th>Хичээлийн нэр</th>
                                <th style="width: 30px"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                :key="i"
                                v-for="(l, i) in lessonAnnualObj.lesson.list"
                              >
                                <td class="text-muted">{{ i + 1 }}</td>
                                <td>
                                  <a
                                    @click="lessonDetail(l.id)"
                                    role="button"
                                    >{{ l.name }}</a
                                  >
                                  <a
                                    v-if="lessonCur == l.id"
                                    @click="lessonClose()"
                                    style="float: right"
                                  >
                                    <feather
                                      type="x"
                                      class="tx-danger"
                                    ></feather>
                                  </a>
                                </td>
                                <td>
                                  <a @click="taskDetail(l.id)" role="button">
                                    <feather
                                      type="external-link"
                                      :size="16"
                                    ></feather>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="card mg-t-20">
                        <div class="card-header d-flex">
                          {{ mode == 2 ? "Хичээлийн" : "Сургалтын" }} ирц идэвх
                          <div class="mg-l-auto">
                            <Pagination
                              @current-change="changePage"
                              small
                              layout="prev, next, jumper, total"
                              :total="taskViewLogData.allCount"
                            ></Pagination>
                          </div>
                        </div>
                        <div class="card-body" style="padding: 0">
                          <table class="table-god table table-bordered w-full">
                            <thead style="font-size: 10px">
                              <tr>
                                <th style="width: 40px">№</th>
                                <th>Хэрэглэгч</th>
                                <th style="width:120px">Огноо</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="(l, i) in taskViewLogData.logs">
                                <tr
                                  v-if="isDrawGroup(i)"
                                  style="background: lavender !important"
                                  :key="i"
                                >
                                  <td
                                    colspan="3"
                                    class="text-center pd-0-f tx-12"
                                  >
                                    {{ l.date | moment("YYYY.MM.DD, dddd") }}
                                  </td>
                                </tr>
                                <tr :key="i + 'g'">
                                  <td class="text-muted">{{ i + 1 }}</td>
                                  <td>{{ l.userName }}</td>
                                  <td class="text-center">
                                    {{ l.date | moment("HH:mm") }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="card">
                        <div class="card-header d-flex">
                          {{ mode == 2 ? "Хичээлийн" : "Сургалтын" }} хандалт
                          <div class="mg-l-auto">
                            <a
                              @click="
                                filterCourse.groupMode = 0;
                                courseViewLog(courseCur);
                              "
                              :class="{
                                'text-muted': filterCourse.groupMode == 0
                              }"
                            >
                              <i
                                v-if="filterCourse.groupMode == 0"
                                class="icon ion-md-checkmark"
                              ></i>
                              Сараар
                            </a>
                            <a
                              @click="
                                filterCourse.groupMode = 1;
                                courseViewLog(courseCur);
                              "
                              :class="{
                                'text-muted': filterCourse.groupMode == 1
                              }"
                            >
                              <i
                                v-if="filterCourse.groupMode == 1"
                                class="icon ion-md-checkmark"
                              ></i>
                              Өдрөөр
                            </a>
                          </div>
                        </div>
                        <div class="card-body">
                          <apexchart
                            :key="chartKey + '_course'"
                            height="350"
                            :options="chartOptionsCourse"
                            :series="seriesCourse"
                          ></apexchart>
                        </div>
                      </div>

                      <div class="card mg-t-20">
                        <div class="card-header d-flex">
                          {{ mode == 2 ? "Хичээлийн" : "Шалгалтын" }} дүн
                          <div
                            class="mg-l-auto"
                            v-if="
                              activity.course.list.filter(
                                x => x.id == courseCur && x.exams.length
                              ).length && lessonCur == null
                            "
                          >
                            <span class="text-muted">Шалгалтын нэр</span>:
                            {{
                              activity.course.list.filter(
                                x => x.id == courseCur && x.exams.length
                              )[0].exams[0].formName
                            }}, <span class="text-muted">Огноо</span>:
                            {{
                              activity.course.list.filter(
                                x => x.id == courseCur && x.exams.length
                              )[0].exams[0].startDate
                                | moment("YYYY.MM.DD HH:mm, dddd")
                            }}
                          </div>
                        </div>
                        <div class="card-body pd-0">
                          <section v-if="mode == 1">
                            <div
                              class="d-flex align-items-center bd-b pd-x-10"
                              v-for="(u, i) in courseAnnualObj.list"
                              :key="i + '_dvn'"
                            >
                              <div class="text-muted">{{ i + 1 }}</div>
                              <div class="text-center pd-x-10">
                                <h2>{{ u.examData.avsanOnoo }}</h2>
                              </div>
                              <div
                                @click="handleUserInfoModal(u.user.id)"
                                role="button"
                              >
                                <div class="d-flex align-items-center">
                                  <div class="mg-r-10">
                                    <span
                                      class="ivu-avatar ivu-avatar-circle ivu-avatar-default ivu-avatar-image"
                                    >
                                      <img
                                        :src="`${u.user.avator}`"
                                        class="w-full"
                                      />
                                    </span>
                                  </div>
                                  <div>
                                    <a>{{ u.user.fullName }}</a>
                                    <div class="tx-thin tx-11 text-muted">
                                      [{{ u.user.loginName }}], [{{
                                        u.user.register
                                      }}], [{{ u.user.mobile }}], [{{
                                        u.user.position
                                      }}]
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mg-l-auto">
                                <h2>
                                  {{
                                    u.examData.dun > 0
                                      ? u.examData.dun.toFixed(2)
                                      : 0
                                  }}
                                </h2>
                              </div>
                              <div class="mg-x-10">
                                <h2>{{ u.examData.pointAdd }}</h2>
                              </div>
                              <div class="">
                                <h2
                                  v-if="
                                    courseAnnualObj.config.course.solveResult ==
                                      1
                                  "
                                >
                                  {{
                                    (
                                      (u.yavtsData.irtsPoint *
                                        courseAnnualObj.config.course
                                          .irtsPerc) /
                                        100 +
                                      (u.yavtsData.yavtsPoint *
                                        courseAnnualObj.config.course
                                          .yavtsPerc) /
                                        100 +
                                      (courseAnnualObj.config.course.examPerc *
                                        u.examData.dun) /
                                        100 +
                                      u.yavtsData.pointAdd
                                    ).toFixed(2)
                                  }}
                                </h2>
                                <h2 v-else>
                                  {{
                                    (
                                      u.examData.dun + u.yavtsData.pointAdd
                                    ).toFixed(2) + "%"
                                  }}
                                </h2>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </vue-custom-scrollbar>
            </div>
          </div>
        </div>
      </div>
    </template>

    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <task-dialog
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      @on-task-close="taskDialogSide.id = 0"
    />
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { mapActions } from "vuex";
import { request } from "@/api/all";
const moment = require("moment");
var LTT = require("list-to-tree");
var _ = require("lodash");
import VueApexCharts from "vue-apexcharts";
import { hasOneOf } from "@/libs/tools";
import { Tree, Pagination, Cascader } from "element-ui";

export default {
  components: {
    Pagination, Tree,
    Cascader,
    apexchart: VueApexCharts,
    vueCustomScrollbar,

    taskDialog: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data: () => ({
    filterParam:{
      fullname: '',
      userDepCur: null,
      userIds: [],
      trkey: 1,
    },
    departsFlat: [],
    departs: [],
    defaultProps: {
      children: "children",
      label: "label",
      iid: "id"
    },

    goUsers: [],
    usersRdy: false,
    onlineUsers: 0,
    myResBaseUrl: "https://res.gosmart.mn/",
    filter: {
      year: null,
      month: null
    },
    activity: {
      content:{
        topList: 0,
        extGrouped: []
      },
      invoice:{
        all: 0
      },
      user:{
        all: 0
      },
      course:{
        list: []
      }
    },
    fetched: false,
    loading: false,

    mode: 0,
    courseCur: null,
    lessonCur: null,
    filterData: [],

    taskDialogSide: {
      show: false,
      id: 0,
      key: 0
    },

    fileDialog: {
      show: false,
      id: 0
    },

    chartKey: 0,
    series: [{ name: "Эхлэх сургалт", data: [] }],
    seriesMember: [{ name: "Гишүүний тоо", data: [] }],
    chartOptions: {
      chart: {
        height: 350,
        type: "bar"
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top" // top, center, bottom
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"]
        }
      },

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        position: "bottom",
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        tooltip: {
          enabled: true
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      }
    },

    seriesCourse: [
      {
        name: "Хандалт",
        data: [44, 55, 41, 67, 22, 43]
      }
    ],
    chartOptionsCourse: {
      chart: {
        type: "line",
        height: 350,
        stacked: true,
        toolbar: {
          show: true
        },
        zoom: {
          enabled: true
        }
      },
      xaxis: {
        categories: []
      }
    },
    filterCourse: {
      courseId: null,
      groupMode: 1
    },
    taskViewLogData: {
      allCount: null,
      logs: [],
      page: 1,
      size: 20
    },
    courseAnnualObj: {
      list: [],
      config: {}
    },
    lessonAnnualObj: {
      exam: {},
      lesson: {},
      member: {}
    }
  }),
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {

    request({
      api: { method: "GET", url: "Learn/AnnualStatFilters" },
      store: this.$store
    }).then(res => {
      if (res != false) {
        let self = this;
        let yrs = _.uniqBy(res.data.list, "year");
        yrs.forEach(e => {
          self.filterData.push({
            label: e.year + " он",
            value: e.year,
            children: res.data.list
              .filter(x => x.year == e.year)
              .map(z => {
                return {
                  label: z.month + " сар",
                  value: z.year + "." + z.month
                };
              })
          });
        });

        this.$nextTick(() => {
          this.init(new Date().getFullYear(), null);
        });
      }
    });
    this.handleAside({ minimize: true, maximize: false });
    //this.init();
  },
  computed: {
    users_filtered: function() {
      // if(!(this.filterParam.userIds == null && this.filterParam.userIds.length == 0 && this.filterParam.userDepCur == null)){
      //   console.log('q1');
      // }else{
      //   console.log('q2');
      // }
      

      let self = this;
      let _un = self.filterParam.fullname.toLowerCase();

      return this.$store.state.signalr.users.filter(u => {
        //console.log(u, this.filterParam.userDepCur)
        return (
          u.isOnline=='b' && 
          
          u.f02 != null &&
          u.f02.toLowerCase().indexOf(_un) > -1 
          && (this.filterParam.userDepCur == null ? true : hasOneOf(this.filterParam.userIds, [u.f01]) )
        );
      });
    }
  },
  methods: {
    ...mapActions(["handleAside", "handleUserInfoModal", "handleGroupUsers"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    clrFltr(){
      this.filterParam.userDepCur = null;
      this.filterParam.fullname = '';
      this.filterParam.userIds = [];
      this.filterParam.trkey++;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    departNodeClicked(depId) {
      this.filterParam.userDepCur = depId;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetUserIdsByDepartId" },
        params: {
          departId: depId,
          //tagId: this.filterParam.userTagCur,
          //systemFlag: 1,
          //gid: this.filterParams.groupId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('mapped uids', res.data.userIds.map(x => { return x.userId; }));
          this.filterParam.userIds = res.data.userIds.map(x => {
            return x.userId;
          });
          //console.log('baazaas', this.filterParam.userIds);
        }
      });
    },
    initDeparts() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetDepartTreeData" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res.data.departs', res.data.departs);
          this.departsFlat = res.data.departs;
          var ltt = new LTT(res.data.departs, {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children"
          });
          this.departs = ltt.GetTree();
        }
      });
    },
    loadUsersF(){
      //console.log('tab fired');
      this.toggleBodyClass("addClass", "dynamic-locker");
      this.handleGroupUsers({ store: this.$store }).then(()=>{
        this.toggleBodyClass("removeClass", "dynamic-locker");
        this.initDeparts();
      });
    },
    init(year, month) {
      this.loading = true;
      request({
        api: { method: "get", url: "Learn/AnnualStatData" },
        params: { year: year, month: month },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log(res.data.course);
          this.loading = false;
          this.activity = res.data;

          this.filter.year = year;

          if (month != undefined) {
            this.filter.month = month;
            //this.chartOptions.title.text=year+' оны'+ month+'-р сарын сургалтын график /эхлэх өдрөөр/';
            this.chartOptions.xaxis.categories = res.data.course.grouped.map(
              x => {
                return x.key + "-н";
              }
            );
            this.series[0].data = res.data.course.grouped.map(x => {
              return x.count;
            });
            this.seriesMember[0].data = res.data.course.grouped.map(x => {
              return x.memberCount;
            });
          } else {
            this.chartOptions.xaxis.categories = res.data.course.grouped.map(
              x => {
                return x.key + "-р сар";
              }
            );
            this.series[0].data = res.data.course.grouped.map(x => {
              return x.count;
            });
            this.seriesMember[0].data = res.data.course.grouped.map(x => {
              return x.memberCount;
            });
            //this.chartOptions.title.text=year+' оны сургалтын график /эхлэх огноогоор/';

            this.filter.month = null;
          }
          this.chartKey++;
        }
      });
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    yearOnChange(value) {
      this.mode = 0;
      if (value.length > 0) {
        if (value.length == 1) {
          this.init(value[0]);
        } else if (value.length == 2) {
          this.init(value[0], value[1].split(".")[1]);
        }
      }
    },
    courseDetail(c) {
      this.mode = 1;
      this.courseCur = c.id;
      this.lessonCur = null;
      this.courseViewLog(this.courseCur);
      this.taskViewLog(this.courseCur);
      this.lessonAnnual(this.courseCur);
      this.courseAnnual(this.courseCur);
    },
    courseViewLog(cid) {
      request({
        api: { method: "POST", url: "TaskDashboard/taskViewGroupByDate" },
        data: { id: cid, groupMode: this.filterCourse.groupMode },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.seriesCourse[0].data = res.data.list.map(x => {
            return x.webCount;
          });
          if (this.filterCourse.groupMode == 0) {
            this.chartOptionsCourse.xaxis.categories = res.data.list.map(x => {
              return moment(x.key).format("YYYY/MM");
            });
          } else {
            this.chartOptionsCourse.xaxis.categories = res.data.list.map(x => {
              return moment(x.key).format("YY/MM/DD");
            });
          }

          this.chartKey++;
        }
      });
    },
    taskViewLog(id) {
      request({
        api: { method: "GET", url: "Task/TaskViewLogs" },
        params: {
          id: id,
          page: this.taskViewLogData.page - 1,
          size: this.taskViewLogData.size
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.taskViewLogData.page = 1;

          this.taskViewLogData.allCount = res.data.allCount;
          this.taskViewLogData.logs = res.data.logs;
        }
      });
    },
    lessonAnnual(id) {
      request({
        api: { method: "GET", url: "learn/AnnualStatLessonList" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.lessonAnnualObj = res.data;
        }
      });
    },
    courseAnnual(id) {
      this.courseAnnualObj.list = [];
      request({
        api: { method: "GET", url: "learn/CourseAnnualData" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.courseAnnualObj.list = res.data.list;
          this.courseAnnualObj.config = res.data.config;
        }
      });
    },

    isDrawGroup(i) {
      if (i == 0) {
        return true;
      } else if (
        moment(this.taskViewLogData.logs[i].date).format("YYYY/MM/DD") !=
        moment(this.taskViewLogData.logs[i - 1].date).format("YYYY/MM/DD")
      )
        return true;
      else return false;
    },
    changePage(pg) {
      //console.log(pg);
      this.taskViewLogData.page = pg;
      this.taskViewLog(this.courseCur);
    },
    lessonDetail(id) {
      this.lessonCur = id;
      this.mode = 2;
      this.taskViewLog(id);
      this.courseViewLog(id);
    },
    lessonClose() {
      this.mode = 1;
      this.lessonCur = null;
      this.taskViewLog(this.courseCur);
    },
    taskDetail(id) {
      this.taskDialogSide.id = id;
    }
  }
};
</script>
